export default __webpack_public_path__ + "static/media/CoinbaseWallet.fa95edda.svg";